/* eslint-disable linebreak-style */
import React from 'react';
const MedicalHardshipStepShared = () => (
  <ol>
    <li>
    Benefit does not extend to self-employed, retired, or employed by a member of your Household.
    </li>
    <li>
    Attach a copy of your approved leave notice, that shows your employer’s name, address, and contact information for the approving person.
    </li>
  </ol>
);

export default MedicalHardshipStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/components/MedicalHardshipStepShared.js